import { createContext, useContext, useState } from "react";

const PlayerContext = createContext(null);

export const PlayerProvider = ({ children }) => {
  const [track, setTrack] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const playTrack = (episode) => {
    if (track && track.id === episode.id) {
      setIsPlaying((p) => !p);
    } else {
      setTrack(episode);
      setIsPlaying(true);
    }
  };

  const closePlayer = () => {
    setTrack(null);
    setIsPlaying(false);
  };

  return (
    <PlayerContext.Provider
      value={{ track, isPlaying, setIsPlaying, playTrack, closePlayer }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => useContext(PlayerContext);
